var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLupIcon1 = function SvgLupIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34 20c0 7.732-6.268 14-14 14S6 27.732 6 20 12.268 6 20 6s14 6.268 14 14m1 0c0 8.284-6.716 15-15 15S5 28.284 5 20 11.716 5 20 5s15 6.716 15 15m-4 0c0 6.075-4.925 11-11 11S9 26.075 9 20 13.925 9 20 9s11 4.925 11 11m1 0c0 6.627-5.373 12-12 12S8 26.627 8 20 13.373 8 20 8s12 5.373 12 12",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.104 21.768v-3.81h1.647v3.758a2.32 2.32 0 0 1-2.316 2.316h-.772a2.265 2.265 0 0 1-2.265-2.265V18.84l-4.118-2.94h5.765v5.868c0 .454.37.824.823.824h.412c.453 0 .824-.37.824-.824m4.118-3.81h1.647c1.024 0 1.852.83 1.852 1.854v.412a1.85 1.85 0 0 1-1.852 1.852H23.22v1.956h-1.646V17.96zm1.147 2.847c.392 0 .706-.319.706-.705v-.237a.706.706 0 0 0-.706-.705h-1.148v1.647z",
    clipRule: "evenodd"
  })));
};
export default SvgLupIcon1;